import { render, staticRenderFns } from "./zirconia.vue?vue&type=template&id=d70f02f6&scoped=true"
import script from "./zirconia.vue?vue&type=script&lang=js"
export * from "./zirconia.vue?vue&type=script&lang=js"
import style0 from "./zirconia.vue?vue&type=style&index=0&id=d70f02f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70f02f6",
  null
  
)

export default component.exports